import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Sparkles, Loader2, ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

/**
 * StartTrialButton
 * - Only shown if user is `free` and hasn't used trial yet.
 * - On click: POST /api/auth/start-trial, updates local user, refreshes.
 */
export default function StartTrialButton({ variant = "primary", testId = "start-trial-btn" }) {
  const { user, setUser } = useAuth();
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  const eligible = user && user.subscription_tier === "free" && !user.has_used_trial && !user.trial_active;
  if (!eligible) return null;

  const start = async () => {
    setBusy(true);
    try {
      const res = await api.post("/auth/start-trial");
      setUser(res.data.user);
      localStorage.setItem("gf_user", JSON.stringify(res.data.user));
      toast.success("Pro trial activated for 7 days!");
      navigate("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Could not start trial");
    } finally {
      setBusy(false);
    }
  };

  const primary = variant === "primary";
  return (
    <Button
      onClick={start}
      disabled={busy}
      data-testid={testId}
      className={
        primary
          ? "bg-[#C1654B] text-white hover:bg-[#A0533E] rounded-md"
          : "bg-white text-[#1C3F35] hover:bg-white/90 rounded-md border-0"
      }
    >
      {busy ? <Loader2 className="w-4 h-4 animate-spin"/> : (
        <><Sparkles className="w-4 h-4 mr-2"/>Try Pro free for 7 days<ArrowRight className="w-4 h-4 ml-2"/></>
      )}
    </Button>
  );
}
